import * as React from 'react';
import defaultTheme from './default-theme';
import { GlobalStyle, ThemeProvider } from '../system';
import CSSReset from './css-reset';
/**
 * The global provider that must be added to make all TQC components
 * work correctly
 */
export var TQCProvider = props => {
  var {
    children,
    resetCSS = true,
    theme = defaultTheme
  } = props;
  return /*#__PURE__*/React.createElement(ThemeProvider, {
    theme: theme
  }, resetCSS && /*#__PURE__*/React.createElement(CSSReset, null), /*#__PURE__*/React.createElement(GlobalStyle, null), children);
};